import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Invokes `onDismiss` when `pathname` or `search` changes while `open` is true.
 * Use with modals that portal into `shell-main-content` so navigating via shell keeps working.
 */
export function useDismissModalOnRouteChange(open, onDismiss) {
  const location = useLocation();
  const prevKeyRef = useRef(`${location.pathname}${location.search}`);

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;
    if (prevKeyRef.current !== key) {
      if (open) onDismiss?.();
      prevKeyRef.current = key;
    }
  }, [location.pathname, location.search, open, onDismiss]);
}
